module.exports = __webpack_public_path__ + "img/dropdown.60cd4193.svg";